let total_essay_fields = 0;
let total_bounced_fields = 0;
let existing_essay_fields = 100;
let existing_bounced_fields = 100;

window.add_essay_fields = function(link, association, fields_to_clone, view) {
  if (view === 'new')
  {
    total_essay_fields++;
  } else
  {
    existing_essay_fields++;
    total_essay_fields = existing_essay_fields;
  }
  let regexp = new RegExp("new_" + association, "g");
  $(link).parent().parent().parent().children(".essay").append(fields_to_clone.replace(regexp, total_essay_fields));
  $(function () {
    return $('select.chosen-select').chosen({
      allow_single_deselect: true,
      no_results_text: 'No results matched',
      width: '100%'
    });
  });
}

window.remove_essay_fields = function(link) {
  $(link).siblings().val(1);
  $(link).parent().parent().remove();
}


window.add_bounce_fields = function(link, association, fields_to_clone, view) {
  if (view === 'new')
  {
    total_bounced_fields++;
  } else
  {
    existing_bounced_fields++;
    total_bounced_fields = existing_bounced_fields;
  }
  let regexp = new RegExp("new_" + association, "g");
  $(link).parent().parent().parent().children(".bounce").append(fields_to_clone.replace(regexp, total_bounced_fields));
  $(function () {
    return $('select.chosen-select').chosen({
      allow_single_deselect: true,
      no_results_text: 'No results matched',
      width: '100%'
    });
  });
}

window.remove_bounce_fields = function(link) {
  $(link).siblings().val(1);
  $(link).parent().parent().remove();
}
